export default __webpack_public_path__ + "static/HCI210学生奨励賞-a640587cd08de9560df35ae5c9d411ac.pdf";